/**
 * Централизованное управление базовым URL для всего приложения
 *
 * СТРАТЕГИЯ РОУТИНГА:
 *
 * Проект работает по базовому роуту /prompthub во всех окружениях:
 * - Продакшен: https://alice.yandex.ru/prompthub
 * - Тестовые стенды: https://hanky.ai-platform-stage.yandex.ru/prompthub
 * - Локальная разработка: https://localhost.msup.yandex.ru/prompthub
 *
 * API доступно по адресу /prompthub/api
 *
 * АРХИТЕКТУРА:
 *
 * У нас два Express приложения: frontend и api
 *
 * Ключевая идея - приложения НЕ ЗНАЮТ про BASE_URL /prompthub в своем внутреннем роутинге:
 * - Frontend Express приложение обрабатывает роуты от корня /
 * - API Express приложение обрабатывает роуты от корня /
 *
 * КАК ДОСТИГАЕТСЯ МАППИНГ НА /prompthub:
 *
 * 1. ЛОКАЛЬНАЯ РАЗРАБОТКА:
 *    В index.js корневое Express приложение монтирует:
 *    - app.use('/prompthub', frontendApp) - frontend доступен по /prompthub
 *    - app.use('/prompthub/api', apiApp) - API доступен по /prompthub/api
 *
 * 2. ТЕСТОВЫЕ СТЕНДЫ И ПРОДАКШЕН:
 *    Балансеры вырезают BASE_URL из пути перед передачей в приложение:
 *
 *    Для API:
 *    matcher: path_re: '/prompthub/api/.*'
 *    rewrite: pattern: /prompthub/api/(.*) -> replacement: /%1
 *
 *    Для Frontend:
 *    matcher: path_re: '/prompthub/.*'
 *    rewrite: pattern: /prompthub/(.*) -> replacement: /%1
 *
 * ИСПОЛЬЗОВАНИЕ BASE_URL В КОМПОНЕНТАХ:
 *
 * - React Router basename:
 *   - frontend/src/client/App.tsx - BrowserRouter basename="/prompthub"
 *   - frontend/src/server/ServerApp.tsx - StaticRouter basename="/prompthub"
 *
 * - Загрузка статических ассетов:
 *   - frontend/src/server/app.ts - пути к JS/CSS файлам и favicon
 *   - webpack publicPath - для правильной загрузки чанков
 *
 * - API вызовы с фронтенда - базовый путь для fetch запросов
 */

// Базовый путь приложения
export const BASE_URL = '/prompthub';

// API путь относительно базового
export const API_BASE_URL = `${BASE_URL}/api`;
